import { Dayjs } from "dayjs"
import {
  IWarrantsFilesAccount,
  WarrantsFilesAccountStatus,
  WarrantsFilesDcaType,
  WarrantsFilesType,
} from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsFilesAccount implements IWarrantsFilesAccount {
  constructor(
    public id: number,
    public accountNumber: string,
    public customerName: string | null,
    public dcaType: WarrantsFilesDcaType,
    public fileType: WarrantsFilesType,
    public createdAt: Dayjs,
    public deletedAt: Dayjs | null,
    public jobId: number,
    public status: WarrantsFilesAccountStatus,
    public errorMessage: string | null,
    public retryCount: number,
  ) {}

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }

  get statusDisplay(): string {
    return sentenceCase(this.status)
  }

  get dcaTypeDisplay(): string {
    return sentenceCase(this.dcaType)
  }

  get fileTypeDisplay(): string {
    return sentenceCase(this.fileType)
  }
}
